<div class="attach-existing-entities">
	<div class="header">
		<button mat-icon-button class="close-button" (click)="clearSupport()">
			<mat-icon svgIcon="arrow-left" />
		</button>
		<p class="font-title-large">{{ title() | translate }}</p>
	</div>
	<search-bar />

	<div class="content">
		@if (currentEntity().length === 0 || isLoadingResults()) {
			<div class="spinner">
				<mat-spinner></mat-spinner>
			</div>
		} @else {
			<p class="form-label-large">{{ 'existing_' + entityType() | translate }}</p>
			<div class="entities-list nice-scroll colored-scroll-track visible-scroll">
				@for (entity of currentEntity(); track entity.id) {
					<attached-entity-card
						[entity]="{ type: entityType(), data: entity }"
						[selectedEntityPks]="selectedEntityPks()"
						(isSelected)="selectionChanged($event)"
					></attached-entity-card>
				}
			</div>
		}
		<div class="pagination">
			<au-paginator
				[initialPageSize]="20"
				[nodes]="djangoPaginationData()"
				(paginationEmit)="paginationUpdateHandler($event)"
			></au-paginator>
		</div>
	</div>
</div>
